<script lang="ts" setup>
import { getLevel2domain, useCookie, useI18n, useNuxtApp } from '#imports'
import { getLocalFromNavigator } from '@/plugins/i18n'
import { StorageKey, SupportLocale } from '@/types/enum'
import { computed, nextTick, ref, watch } from 'vue'
import $track from '~/track/webYunpanPublicModule'

const textMap: Record<SupportLocale, string> = {
  [SupportLocale.ZH_CN]: '查看简体中文页面',
  [SupportLocale.EN_US]: 'View in English',
  [SupportLocale.ZH_TW]: '查看繁體中文頁面',
  [SupportLocale.ID]: 'Lihat dalam bahasa Indonesia',
  [SupportLocale.MS]: 'Pandangan dalam Bahasa Melayu',
  [SupportLocale.KO]: '한국어 페이지 보기',
  [SupportLocale.JA]: '日本語ページを表示',
  [SupportLocale.ES]: 'Ver página en español',
  [SupportLocale.PT]: 'Ver página em português',
  [SupportLocale.RU]: 'Ir para página em russo',
  [SupportLocale.UK]: 'Ir para a página ucraniana',
}

const { locale } = useI18n()
const targetLocale = getLocalFromNavigator()
const shouldShow = ref(true)

const visible = computed(
  () =>
    targetLocale && targetLocale !== locale.value && !useCookie(StorageKey.HIDE_LANG_CHANGE).value && shouldShow.value,
)

const onClosed = () => {
  shouldShow.value = false
  useCookie(StorageKey.HIDE_LANG_CHANGE, {
    domain: getLevel2domain(),
    maxAge: 24 * 60 * 60,
  }).value = 'true'
}

const setLocale = () => {
  useNuxtApp().$i18n.setLocale(targetLocale)
  shouldShow.value = false
  $track.click_language_guide_switch({
    current_address: window.location.href,
    before_language: locale.value,
    after_language: targetLocale as string,
  })
}

watch(locale, () => (shouldShow.value = true))
watch(
  visible,
  async () => {
    await nextTick()
    window.setStyle?.()
  },
  { immediate: true },
)
</script>
<template>
  <div
    v-if="visible"
    class="lang-change"
  >
    <a
      class="pp-link-button"
      href="javascript:void(0)"
      @click="setLocale"
    >
      <div class="title">
        <span v-if="targetLocale">{{ textMap[targetLocale] }}</span>
        <div class="enter" />
      </div>
    </a>
    <div
      class="close"
      @click="onClosed"
    />
  </div>
</template>
<style lang="less" scoped>
.lang-change {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #010103;
  position: relative;
  flex-shrink: 0;

  .title {
    display: flex;
    align-items: center;
    cursor: pointer;

    span {
      font-size: 14px;
      line-height: 22px;
      color: #fff;
    }

    .enter {
      width: 16px;
      height: 16px;
      background: url('@/assets/images/lang-change/enter.png') no-repeat center/cover;
      margin-left: 4px;
    }
  }

  .close {
    cursor: pointer;
    position: absolute;
    right: 42px;
    width: 24px;
    height: 24px;
    background: url('@/assets/images/lang-change/close.png') no-repeat center/cover;
  }
}
</style>
